import { Component, inject, input, output, TemplateRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DepartmentService } from '../../services/department.service';
import { map, Observable, of } from 'rxjs';
import { Department, DepartmentSearchEvent } from 'src/app/features/department/department.model';
import { PagedResult } from '../../models/paging';
import { TypeAheadSelector2Component } from '../type-ahead-selector2/type-ahead-selector2.component';

@Component({
  selector: 'adm-dep-typeahead',
  imports: [TypeAheadSelector2Component],
  templateUrl: './adm-dep-typeahead.component.html',
  styleUrl: './adm-dep-typeahead.component.scss',
})
export class AdmDepTypeaheadComponent {
  departmentService = inject(DepartmentService);
  organizationId = input<number | null>(null);
  excludedDepartmentId = input<number | null>(null);
  departmentId = input<string | null>(null);
  departmentFetched = output<Department[] | null>();
  itemSelected = output<Department | null>();
  resetTrigger = input<{ reset: boolean }>({ reset: false });
  itemTemplate = input<TemplateRef<any>>();
  disabled = input<boolean>(false);
  required = input<boolean>(false);
  validationControl = input<AbstractControl | null>(null);
  requiredErrorText = input<string>('Afdeling skal vælges fra listen');
  clearTypeAhead = output();

  fetchDepartments = (term: string): Observable<Department[]> => {
    const orgId = this.organizationId();
    const searchEvent: DepartmentSearchEvent = {
      query: term,
      paging: { pageIndex: 0, pageSize: 20, length: 0 },
      organizationId: orgId ? orgId : undefined,
    };

    return this.departmentService.getDepartments(searchEvent).pipe(
      map((result: PagedResult<Department>) => {
        const excludedId = this.excludedDepartmentId();
        const departments = result.items.filter(department => department.id !== excludedId);

        this.departmentFetched.emit(departments);
        return departments;
      })
    );
  };

  fetchDepartmentById = (id: string): Observable<Department | null> => {
    const parsedId = parseInt(id);
    if (isNaN(parsedId)) {
      return of(null);
    }
    return this.departmentService.getDepartment(parsedId);
  };

  departmentSelected = (dep?: Department) => {
    this.itemSelected.emit(dep ? dep : null);
  };
}
